import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import { TOrderFormData } from "../models/orderForm";
import mapOrderToShipmentRequest from "../utils/mapOrderToShipmentRequest";

type TShipmentResponse = {
  id: string;
};

const shipmentService = createApiService({
  url: API_ROUTES.SHIPMENT,
  method: "POST",
});

const createOrUpdateShipment = async (order: TOrderFormData): Promise<TServiceReturns<TShipmentResponse, unknown>> => {
  try {
    const data = mapOrderToShipmentRequest(order);
    const response = await shipmentService({ data });
    return response;
  } catch (err) {
    reportError(err, { module: "order" });
    return { isSuccess: false };
  }
};
export default createOrUpdateShipment;
